import React from "react";
import { Row, Col } from "react-bootstrap";

const UserAllOrderCard = ({ cartitem }) => {

  return (
    cartitem.product != null ? (
      <Row className="d-flex mb-2">
        <Col xs="12" sm="4" lg="4" xl="3" className="d-flex justify-content-start">
          <img src={`${cartitem.product.imageCover}`} className="w-100 h-200px" alt="" />
        </Col>
        <Col xs="12" sm="7" lg="8" xl="9" className="py-3">
          <h3 className="fw-bold pt-2 mb-3">
            {cartitem.product.title}
          </h3>
          <p className="fs-20 mb-3">{cartitem.price} LE</p>
          {cartitem.color ? (<p className="mb-0" style={{ backgroundColor: cartitem.color }}></p>) : null}
          <p className="mb-0">{cartitem.count} Items</p>
        </Col>
      </Row >
    ) : (<p className="alert alert-warning mt-3">This product not available now</p>)
  );
};

export default UserAllOrderCard;
